// helpers
import { bindEvents, lodash } from '../../../assets/js/helpers';

// controllers
import ResizeController from '../../../assets/js/controller/resize';

// plugins
import SplitText from '../../../assets/js/plugins/SplitText';

// dom selector
const selector = 'hero-generic';

export default class HeroGeneric {

	constructor(section) {
		this.el = {
			section,
			heading: section.querySelector(`.${selector}__text-heading`)
		};

		// class variable groups

		this.controllers = {
			resize: null
		};

		this.throttled = {
			resize: lodash.throttle(this.measureResize.bind(this), 500, { leading: false, trailing: true })
		};

		// class variables

		this.splits = [];

		// bind events to class scope
		this.events = bindEvents(this);

		// let's mosey
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize

	init() {
		this.measureResize();
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		this.controllers.resize = ResizeController.set({
			update: () => { this.events._onWindowResize(); },
			resize: () => {}
		});
	}

	removeEventListeners() {
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	_onWindowResize() {
		this.throttled.resize();
	}

	//

	measureResize() {

		// split words into individual spans

		for (let i = 0; i < this.splits.length; i++) {
			const split = this.splits[i];
			split.revert();
		}

		this.splits = [];

		const split = new SplitText(this.el.heading, { type: 'words', linesClass: 'word' });

		this.splits.push(split);

		// according to CMS, associate images with designated words

		const schema = JSON.parse(decodeURIComponent(this.el.heading.dataset.schema));

		for (let i = 0; i < split.words.length; i++) {
			const $word = split.words[i];
			const text = $word.textContent.toLowerCase();
			$word.classList.add(text);

			let findCount = 0;
			for (let k = 0; k < schema.words.length; k++) {
				const association = schema.words[k];
				const wordIndex = association.wordIndex || 0;
				const offsetX = (association.offsetX || 0) * 100;
				const offsetY = (association.offsetY || 0) * 100;
				const scale = (association.scale || 1);
				if (association.word === text) {
					if (findCount === wordIndex) {
						const image = document.createElement('img');
						image.setAttribute('src', schema.apiUrl + association.image[0].url);
						image.style.transform = `translateX(${offsetX}%) translateY(${offsetY}%) scale(${scale})`;
						$word.appendChild(image);
						break;
					}
					findCount++;
				}
			}
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
